const computeGoalsSummary = (goals) => {
    const list = Array.isArray(goals) ? goals : []
    const total = list.length
    const reached = list.filter(g => g?.Status === 'bereikt').length
    const percent = total === 0 ? 0 : Math.round((reached / total) * 100)
    return { total, reached, percent }
}

export default computeGoalsSummary
